/**
 * Classic Theme MCP Server
 *
 * Provides AI models with comprehensive design system knowledge including
 * components, design tokens, layout patterns, and validation schemas.
 */

import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { registerResources } from './resources/index.js';
import { registerTools } from './tools/index.js';
import { registerPrompts } from './prompts/index.js';
import packageJson from '../package.json' with { type: 'json' };

/**
 * Creates and configures the MCP server
 */
export function createServer(): McpServer {
  const server = new McpServer({
    name: 'classic-theme',
    version: packageJson.version,
  });

  // Register all MCP primitives
  registerResources(server);
  registerTools(server);
  registerPrompts(server);

  return server;
}
